import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { logout, isLoggedIn, ifAdmin, ifSprzedawca, getLogin } from '../utils/AuthService';
import '../App.css';

class Nav extends Component {

  goToLogin() {
    window.location.href = '/login';
  }

  render() {
    const logged = isLoggedIn();
    return (
      <nav className="navbar navbar-default">
        <div className="navbar-header">
          <Link className="navbar-brand" to="/">Usługi ramiarskie</Link>
        </div>

        <ul className="nav navbar-nav">
          <li>
            {
              ( logged && (ifAdmin() || ifSprzedawca()) ) ? <Link to="/zlecenie">Zlecenia</Link> :  ''
            }
          </li>
          <li>
            {
              ( logged ) ? <Link to="/stanListwy">Stan Listw</Link> :  ''
            }
          </li>
          <li>
            {
              ( logged && ifAdmin() ) ? <Link to="/dictListwy">Cennik</Link> :  ''
            }
          </li>

        </ul>
        <ul className="nav navbar-nav navbar-right">
          {
            logged ? (
              <li style={{ paddingTop: 15, paddingRight: 10, color: '#666' }}>
                Zalogowany: <strong>{getLogin()}</strong>
              </li>
            ) : null
          }
          <li>
           {
             logged
               ? (<button className="btn btn-danger log" onClick={() => logout()}>Wyloguj</button>)
               : (<button className="btn btn-info log" onClick={this.goToLogin}>Zaloguj</button>)
           }
          </li>
        </ul>
      </nav>
    );
  }
}

export default Nav;



// WEBPACK FOOTER //
// ./src/components/Nav.js